import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f51cb91"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flex-grow-1 relative" }
const _hoisted_3 = {
  key: 0,
  class: "pwd-icon-wrapper"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "form-item"
}
const _hoisted_6 = {
  key: 2,
  class: "form-item radio"
}
const _hoisted_7 = {
  key: 4,
  class: "form-item"
}
const _hoisted_8 = {
  key: 5,
  class: "form-item"
}

import { ref, watch, computed, useSlots, useAttrs } from 'vue';
  import { FormItem, InputType } from '@/types/form';
  import { useI18n } from 'vue-i18n';
  import _ from 'lodash';

  type From = {
    [propName: string]: any;
  }

  interface IProps {
    form: From,
    config: FormItem
    className?: string | string[];
  }

  
  const __default__ = {
    // 默认ture，外面@input会收到原生input和组件input两个事件触发
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    form: null,
    config: null,
    className: null
  },
  emits: ['change'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    form: From,
    config: FormItem
    className?: string | string[];
  }

  const slots = useSlots();
  
  
  const getDefaultData = () => {
    const value = _.get(props, `form.${props.config.key}`);
    if (value) {
      return value;
    }
    return props.config.type === 'checkbox' ? [] : '';
  };
  const data = ref(getDefaultData());
  const inputType = ref<InputType>(props.config.inputType || 'text');
  const { t } = useI18n();
  const checkboxValue = ref();

  const handleTriggerPwd = () => {
    inputType.value = inputType.value === 'password' ? 'text' : 'password';
  };

  const attrs = useAttrs();

  const selectOptions = computed(() => {
    return [
      {
        text: props.config.placeholder || t('defaultOptionText'),
        value: ''
      },
      ...(props.config.options || [])
    ];
  });

  // Array数据监听并发送事件
  const dataChange = (data: any) => {
    // 用于触发校验
    if (props.config.required) {
      checkboxValue.value = data.length ? 'placeholder' : null;
    }
    emits('change', { key: props.config.key, value: data });
  };

  watch(data, () => {
    emits('change', { key: props.config.key, value: data.value });
  });

  watch(props.form, () => {
    data.value = _.get(props, `form.${props.config.key}`);
  }, { deep: true, immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_radio_group = _resolveComponent("b-form-radio-group")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form_checkbox_group = _resolveComponent("b-form-checkbox-group")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_group = _resolveComponent("b-form-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group-item-wrapper", __props.className])
  }, [
    _createVNode(_component_b_form_group, {
      label: __props.config.label,
      description: __props.config.description,
      "label-class": ['group-item-label', { required: __props.config.required }]
    }, _createSlots({
      default: _withCtx(() => [
        (__props.config.type === 'input')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: __props.config.key,
              class: "form-item d-flex"
            }, [
              _renderSlot(_ctx.$slots, "inputBefore"),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_b_form_input, _mergeProps({
                  id: String(__props.config.key),
                  modelValue: data.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
                  name: String(__props.config.key),
                  required: __props.config.required,
                  type: inputType.value,
                  disabled: __props.config.disabled,
                  readonly: __props.config.readonly,
                  placeholder: __props.config.placeholder,
                  min: __props.config.min,
                  max: __props.config.max,
                  pattern: __props.config.pattern
                }, _unref(attrs)), null, 16, ["id", "modelValue", "name", "required", "type", "disabled", "readonly", "placeholder", "min", "max", "pattern"]),
                (__props.config.triggerPwd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("img", {
                        src: inputType.value === 'password' ? require('@/assets/icon/pwd-off.png') : require('@/assets/icon/pwd-on.png'),
                        class: "icon pointer",
                        onClick: handleTriggerPwd
                      }, null, 8, _hoisted_4)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _renderSlot(_ctx.$slots, "inputAfter")
            ], 8, _hoisted_1))
          : _createCommentVNode("", true),
        (__props.config.type === 'select')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_b_form_select, {
                id: String(__props.config.key),
                modelValue: data.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data).value = $event)),
                name: String(__props.config.key),
                options: _unref(selectOptions),
                required: __props.config.required,
                disabled: __props.config.disabled,
                readonly: __props.config.readonly,
                placeholder: __props.config.placeholder
              }, null, 8, ["id", "modelValue", "name", "options", "required", "disabled", "readonly", "placeholder"])
            ]))
          : _createCommentVNode("", true),
        (__props.config.type === 'radio')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_b_form_radio_group, {
                id: String(__props.config.key),
                modelValue: data.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data).value = $event)),
                options: __props.config.options,
                name: String(__props.config.key),
                disabled: __props.config.disabled,
                readonly: __props.config.readonly,
                required: __props.config.required
              }, null, 8, ["id", "modelValue", "options", "name", "disabled", "readonly", "required"])
            ]))
          : _createCommentVNode("", true),
        (__props.config.type === 'checkbox')
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["form-item checkbox", { required: __props.config.required }])
            }, [
              (__props.config.required)
                ? (_openBlock(), _createBlock(_component_b_form_checkbox, {
                    key: 0,
                    id: String(__props.config.key) + '-placeholder',
                    modelValue: checkboxValue.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkboxValue).value = $event)),
                    required: Boolean(__props.config.required),
                    name: String(__props.config.key) + '-placeholder',
                    value: "placeholder"
                  }, null, 8, ["id", "modelValue", "required", "name"]))
                : _createCommentVNode("", true),
              _createVNode(_component_b_form_checkbox_group, {
                id: String(__props.config.key),
                modelValue: data.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data).value = $event)),
                options: __props.config.options,
                name: String(__props.config.key),
                disabled: Boolean(__props.config.disabled),
                readonly: Boolean(__props.config.readonly),
                onChange: dataChange
              }, null, 8, ["id", "modelValue", "options", "name", "disabled", "readonly"])
            ], 2))
          : _createCommentVNode("", true),
        (__props.config.type === 'textarea')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_b_form_textarea, {
                id: String(__props.config.key),
                modelValue: data.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data).value = $event)),
                name: String(__props.config.key),
                required: __props.config.required,
                type: inputType.value,
                disabled: __props.config.disabled,
                readonly: __props.config.readonly,
                placeholder: __props.config.placeholder,
                rows: __props.config.rows || 3
              }, null, 8, ["id", "modelValue", "name", "required", "type", "disabled", "readonly", "placeholder", "rows"])
            ]))
          : _createCommentVNode("", true),
        (__props.config.type === 'custom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "custom"),
              _createVNode(_component_b_form_input, _mergeProps({
                id: String(__props.config.key),
                modelValue: data.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data).value = $event)),
                class: "custom-placehoder-input",
                name: String(__props.config.key),
                required: __props.config.required,
                type: inputType.value,
                disabled: __props.config.disabled,
                readonly: __props.config.readonly,
                placeholder: __props.config.placeholder,
                min: __props.config.min,
                max: __props.config.max,
                pattern: __props.config.pattern
              }, _unref(attrs)), null, 16, ["id", "modelValue", "name", "required", "type", "disabled", "readonly", "placeholder", "min", "max", "pattern"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      _renderList(__props.config.slots, (slot, slotName) => {
        return {
          name: slotName,
          fn: _withCtx((scope) => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(slot), _normalizeProps(_guardReactiveProps(scope)), null, 16))
          ])
        }
      }),
      _renderList(_unref(slots), (slot, slotName) => {
        return {
          name: slotName,
          fn: _withCtx((scope) => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(slot), _normalizeProps(_guardReactiveProps(scope)), null, 16))
          ])
        }
      })
    ]), 1032, ["label", "description", "label-class"])
  ], 2))
}
}

})